module.exports = new __parcel__URL__("security-permissions.ebb7eed7.svg").toString();